import { AntdProvider } from '@/app/providers/AntdProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { AppRouter } from '@/app/router';

export default function App() {
  return (
    <AntdProvider>
      <QueryProvider>
        <AppRouter />
      </QueryProvider>
    </AntdProvider>
  );
}
